/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionMode } from './PalAuthSubmissionMode';
import {
    PalAuthSubmissionModeFromJSON,
    PalAuthSubmissionModeFromJSONTyped,
    PalAuthSubmissionModeToJSON,
    PalAuthSubmissionModeToJSONTyped,
} from './PalAuthSubmissionMode';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
    PalAuthPlatformPayorFormToJSONTyped,
} from './PalAuthPlatformPayorForm';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';
import type { PalSubmissionListEntryTimExecution } from './PalSubmissionListEntryTimExecution';
import {
    PalSubmissionListEntryTimExecutionFromJSON,
    PalSubmissionListEntryTimExecutionFromJSONTyped,
    PalSubmissionListEntryTimExecutionToJSON,
    PalSubmissionListEntryTimExecutionToJSONTyped,
} from './PalSubmissionListEntryTimExecution';
import type { PalAuthSubmissionStatusInfo } from './PalAuthSubmissionStatusInfo';
import {
    PalAuthSubmissionStatusInfoFromJSON,
    PalAuthSubmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionStatusInfoToJSON,
    PalAuthSubmissionStatusInfoToJSONTyped,
} from './PalAuthSubmissionStatusInfo';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalAuthSubmissionGeneratedDocument } from './PalAuthSubmissionGeneratedDocument';
import {
    PalAuthSubmissionGeneratedDocumentFromJSON,
    PalAuthSubmissionGeneratedDocumentFromJSONTyped,
    PalAuthSubmissionGeneratedDocumentToJSON,
    PalAuthSubmissionGeneratedDocumentToJSONTyped,
} from './PalAuthSubmissionGeneratedDocument';
import type { PalSubmissionListEntryLead } from './PalSubmissionListEntryLead';
import {
    PalSubmissionListEntryLeadFromJSON,
    PalSubmissionListEntryLeadFromJSONTyped,
    PalSubmissionListEntryLeadToJSON,
    PalSubmissionListEntryLeadToJSONTyped,
} from './PalSubmissionListEntryLead';

/**
 * 
 * @export
 * @interface PalSubmissionListEntry
 */
export interface PalSubmissionListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     */
    status_updated_at?: string;
    /**
     * The submission's insert timestamp ("analysis started").
     */
    created_at?: string;
    /**
     * 
     */
    external_id?: string;
    /**
     * 
     */
    is_non_submission_flow?: boolean;
    /**
     * 
     */
    is_oon?: boolean;
    /**
     * 
     */
    can_revert_status?: boolean;
    /**
     * 
     */
    can_restart?: boolean;
    /**
     * 
     */
    submission_mode?: PalAuthSubmissionMode;
    /**
     * Normalized fax number the eFax was sent from. Null when sent from the shared/generic exacare fax number rather than a dedicated eFax inbox number.
     */
    sender_fax_number?: string;
    /**
     * 
     */
    lead?: PalSubmissionListEntryLead;
    /**
     * 
     */
    should_sync_remote_status?: boolean;
    /**
     * 
     */
    is_syncing_remote_status?: boolean;
    /**
     * 
     */
    tim_execution?: PalSubmissionListEntryTimExecution;
    /**
     * 
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * 
     */
    status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     */
    previous_status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    generated_document?: PalAuthSubmissionGeneratedDocument;
    /**
     * Whether the submission already has re-auth cycles associated to it
     */
    has_reauths?: boolean;
    /**
     * 
     */
    case_manager?: PalReauthCaseManager;
}



/**
 * Check if a given object implements the PalSubmissionListEntry interface.
 */
export function instanceOfPalSubmissionListEntry(value: object): value is PalSubmissionListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PalSubmissionListEntryFromJSON(json: any): PalSubmissionListEntry {
    return PalSubmissionListEntryFromJSONTyped(json, false);
}

export function PalSubmissionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'status_updated_at': json['status_updated_at'] == null ? undefined : json['status_updated_at'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'is_non_submission_flow': json['is_non_submission_flow'] == null ? undefined : json['is_non_submission_flow'],
        'is_oon': json['is_oon'] == null ? undefined : json['is_oon'],
        'can_revert_status': json['can_revert_status'] == null ? undefined : json['can_revert_status'],
        'can_restart': json['can_restart'] == null ? undefined : json['can_restart'],
        'submission_mode': json['submission_mode'] == null ? undefined : PalAuthSubmissionModeFromJSON(json['submission_mode']),
        'sender_fax_number': json['sender_fax_number'] == null ? undefined : json['sender_fax_number'],
        'lead': json['lead'] == null ? undefined : PalSubmissionListEntryLeadFromJSON(json['lead']),
        'should_sync_remote_status': json['should_sync_remote_status'] == null ? undefined : json['should_sync_remote_status'],
        'is_syncing_remote_status': json['is_syncing_remote_status'] == null ? undefined : json['is_syncing_remote_status'],
        'tim_execution': json['tim_execution'] == null ? undefined : PalSubmissionListEntryTimExecutionFromJSON(json['tim_execution']),
        'auth_platform_form': json['auth_platform_form'] == null ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'status_info': json['status_info'] == null ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': json['previous_status_info'] == null ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'status_updated_by_user': json['status_updated_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'generated_document': json['generated_document'] == null ? undefined : PalAuthSubmissionGeneratedDocumentFromJSON(json['generated_document']),
        'has_reauths': json['has_reauths'] == null ? undefined : json['has_reauths'],
        'case_manager': json['case_manager'] == null ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
    };
}

export function PalSubmissionListEntryToJSON(json: any): PalSubmissionListEntry {
    return PalSubmissionListEntryToJSONTyped(json, false);
}

export function PalSubmissionListEntryToJSONTyped(value?: PalSubmissionListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': PalAuthSubmissionStatusToJSON(value['status']),
        'status_updated_at': value['status_updated_at'],
        'created_at': value['created_at'],
        'external_id': value['external_id'],
        'is_non_submission_flow': value['is_non_submission_flow'],
        'is_oon': value['is_oon'],
        'can_revert_status': value['can_revert_status'],
        'can_restart': value['can_restart'],
        'submission_mode': PalAuthSubmissionModeToJSON(value['submission_mode']),
        'sender_fax_number': value['sender_fax_number'],
        'lead': PalSubmissionListEntryLeadToJSON(value['lead']),
        'should_sync_remote_status': value['should_sync_remote_status'],
        'is_syncing_remote_status': value['is_syncing_remote_status'],
        'tim_execution': PalSubmissionListEntryTimExecutionToJSON(value['tim_execution']),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value['auth_platform_form']),
        'status_info': PalAuthSubmissionStatusInfoToJSON(value['status_info']),
        'previous_status_info': PalAuthSubmissionStatusInfoToJSON(value['previous_status_info']),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_updated_by_user']),
        'generated_document': PalAuthSubmissionGeneratedDocumentToJSON(value['generated_document']),
        'has_reauths': value['has_reauths'],
        'case_manager': PalReauthCaseManagerToJSON(value['case_manager']),
    };
}

